import React from "react";

export class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    console.error("Section error:", error.message);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
